export default "__VITE_ASSET__DpCyzBOw__"